<template>
	<core-modal
		:name="campaign.id + '-trash-modal'"
		class="omapi-modal trash-modal"
		:click-to-close="!isTrashing"
		:is-confirmation="true"
	>
		<modals-content>
			<form @submit.prevent="trash">
				<!-- eslint-disable-next-line vue/no-v-html -->
				<p v-html="message" />
				<p v-if="!campaign.is_split && hasSplits">
					This will <strong>also send the connected split tests to the trash</strong>.
				</p>

				<section class="buttons">
					<core-loading-button
						ref="toFocus"
						class="trash-campaign"
						color="blue"
						size="large"
						button-type="submit"
						:loading="isTrashing"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						:disabled="isTrashing"
						@click.prevent="$modal.hide(campaign.id + '-trash-modal')"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { trash } from '@/campaigns/mixins/trash';

export default {
	mixins: [trash],
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
	computed: {
		hasSplits() {
			return 0 < this.$get('campaign.splits', []).length;
		},
		message() {
			return this.campaign.is_split
				? `Are you sure you want to <strong>permanently delete</strong> the <strong>${this.campaign.name} (${this.campaign.id})</strong> split test campaign?`
				: `Are you sure you want to send the <strong>${this.campaign.name} (${this.campaign.id})</strong> to the trash?`;
		},
	},
};
</script>
